let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("342ya")).then(() => parcelRequire('dAHmc'));